export default __webpack_public_path__ + "static/Places_Placeholder_2.0@2x-343aa85be423af04ef8186f75e40a409.jpg";